import React, { FC } from 'react';

import { triggerLoginModal } from '@/utility/triggerLoginModal';

import RichText from '../static-pages/wagtail/RichText/RichText';
import Button, { ButtonVariants } from '../switchback/Button/Button';
import ResponsiveImage from '../utility/ResponsiveImage/ResponsiveImage';
import css from './ReferralCTAColumn.module.css';

interface IBlockElement {
  type: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
}
interface IReferralCTAColumn {
  blocks: IBlockElement[];
  isAuth?: boolean;
  isTravelCredit?: boolean;
  shareFor: string;
  btnText: string;
  updateRedirectPath?: (path: string) => void;
  path: 'owner' | 'renter';
}

const ReferralCTAColumn: FC<IReferralCTAColumn> = ({
  blocks,
  shareFor,
  btnText,
  isAuth = false,
  isTravelCredit = false,
  updateRedirectPath,
  path,
}) => {
  const handleLogin = () => {
    triggerLoginModal(0);
    const redirectURL = `/referral/${path}`;
    updateRedirectPath && updateRedirectPath(redirectURL);
  };

  const contents = blocks.map((block, idx) => {
    switch (block.type) {
      case 'image':
        return (
          <div className={`overflow-hidden rounded-2xl ${css.maskImage}`} key={idx}>
            <ResponsiveImage
              src={block.value?.url}
              alt={block.value?.title}
              className="object-cover object-center w-full h-full md:hover:scale-105 transition-all duration-500"
            />
          </div>
        );

      case 'richtext':
        return (
          <div key={idx}>
            <RichText content={block.value} />
            <div className="flex items-center mt-6 h-11">
              {isAuth || isTravelCredit ? (
                <Button
                  variant={ButtonVariants.primaryOutlined}
                  className="flex items-center h-11"
                  href={`/referral/${shareFor === 'owner' ? 'renter' : 'owner'}`}
                  testid={shareFor === 'owner' ? 'invite-renter' : 'refer-owner'}>
                  {btnText}
                </Button>
              ) : (
                <Button
                  variant={ButtonVariants.primaryOutlined}
                  className="flex items-center h-11"
                  onClick={handleLogin}>
                  {btnText}
                </Button>
              )}
            </div>
          </div>
        );
    }
  });
  return <div className="grid grid-cols-1 gap-6">{contents}</div>;
};

export default ReferralCTAColumn;
